/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { documentService } from '../../../../api/services/documentService';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import DTOExpiredDocs from './DTOExpiredDocs';
import ExpiredDocsPresenter from './ExpiredDocsPresenter';
import DownloadDocController from '../DownloadDocs/DownloadDocController';
import { toast } from 'react-hot-toast';
import {
  setEmployeeExpiredDocs,
  setExpiredDocsRefreshData,
} from '../../../../infra/aggregates/myProfile/DocumentAggregates/getExpiredEmpDocsSlice';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

function ExpiredDocsController() {
  const { t } = useTranslation();

  const [DocsData, setDocsData] = useState([]);
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [open_modal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();

  const selector = useAppSelector((state) => state.authSlice);

  const storeExpiredDocuments: any = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.empExpDocsData,
  );
  const isLoading = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.expiredDocLoader,
  );

  function callBackFunc(data: any) {
    setDocsData(data);
  }
  const full_path = '';
  const getAttchedDocs = async (id: number) => {
    const response: any = await documentService.getAttachedDoc(id, full_path);

    if (response.response == 'success') {
      const url = response.data.attachment;
      if (url != null) {
        setAttachmentUrl(url);
        setOpenModal(true);
      } else {
        toast.error(t('There is no Attachments!'));
      }
    }
  };
  const getDocsIdItemToBeDeleted = async (_id: number) => {
    await documentService
      .deleteEmpDocs(_id)
      .then((response: any) => {
        const tempExpirdDocs = [...storeExpiredDocuments];
        if (response.response == 'success') {
          const updatedArray: any = _.filter(tempExpirdDocs, (data: any) => {
            return data.id != _id;
          });
          dispatch(setEmployeeExpiredDocs(updatedArray));
          toast.success(t('Deleted Successfully'));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };

  const getDocsIdItemToBeUpdated = async (
    id: number,
    is_expiry_notification: number,
  ) => {
    const payload = {
      id: id,
      empId: selector.emp_id,
      is_expiry_notification: is_expiry_notification,
    };
    const response: any =
      await documentService.updateExpiryEmpDocument(payload);

    if (response.response == 'success') {
      dispatch(setExpiredDocsRefreshData(true));
      toast.success(t('Updated Successfully'));
    }
  };

  const getExpiredNotficationDocsUpdated = async (
    is_expiry_notification: boolean,
  ) => {
    const payload = {
      empId: selector.emp_id,
      is_expiry_notification: is_expiry_notification,
    };
    const response: any =
      await documentService.updateExpiryEmpDocument(payload);

    if (response.response == 'success') {
      dispatch(setExpiredDocsRefreshData(true));
      toast.success(t('Updated Successfully'));
    }
  };

  return (
    <>
      <DTOExpiredDocs setDocumentsData={callBackFunc} />
      <ExpiredDocsPresenter
        allDocsData={DocsData}
        setDocsIdFordeletion={getDocsIdItemToBeDeleted}
        setEmpAttachedDoc={getAttchedDocs}
        isLoading={isLoading}
        trans={t}
        setDocsIdItemToBeUpdated={getDocsIdItemToBeUpdated}
        setExpiredNotficationDocsUpdated={getExpiredNotficationDocsUpdated}
      />
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachmentUrl}
        />
      )}
    </>
  );
}
export default ExpiredDocsController;
